<template>
  <div>
    <b-card no-body>
      <b-card-header class="d-flex align-items-center justify-content-between">
        <b-card-title>
          {{ dataItem.title }}
        </b-card-title>
        <b-card-sub-title>
          Ürün Kodu: {{ dataItem.pcode }}
        </b-card-sub-title>
      </b-card-header>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="dataList"
        striped
        :busy="loading"
        :empty-text="emptyText"
        :show-empty="!!emptyText"
        bordered
        small
        class="mb-0"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle" />
            <strong class="ml-2">Yükleniyor...</strong>
          </div>
        </template>
        <template #head(unit_sale)>
          TAVSİYE EDİLEN<br>BİRİM SATIŞ FİYATI
        </template>
        <template #cell(unit)="data">
          {{ data.item.quantity | toNumber }} {{ data.item.unit }}
        </template>
        <template #cell(unit_cost)="data">
          {{ data.item.unit_cost | toNumber }} {{ data.item.currency }}
          <div class="font-small-2 text-muted">
            (KDV Hariç)
          </div>
        </template>
        <template #cell(unit_sale)="data">
          {{ data.item.unit_sale | toNumber }} {{ data.item.currency }}
          <div class="font-small-2 text-muted">
            (KDV Hariç)
          </div>
        </template>
        <template #cell(tax)="data">
          {{ data.item.tax }}
        </template>
        <template #cell(notes)="data">
          <div class="font-small-3">
            {{ data.item.notes }}
          </div>
        </template>
        <template #cell(username)="data">
          <div class="font-small-3 text-primary font-weight-bold">
            {{ data.item.username }}
          </div>
          <div class="text-primary font-small-3">
            <FeatherIcon
              icon="SaveIcon"
            />
            {{ moment(data.item.modified).format('DD.MM.YYYY') }}
          </div>
        </template>
      </b-table>
      <b-card-footer>
        <b-pagination
          v-if="dataCounts > perPage"
          v-model="currentPage"
          :total-rows="dataCounts"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BTable, BPagination, BCardFooter, BSpinner, BCardTitle, BCardHeader, BCardSubTitle,
} from 'bootstrap-vue'

const tableName = 'product_prices'
export default {
  name: 'ProductsPricesCard',
  components: {
    BCardSubTitle,
    BCardHeader,
    BCardTitle,
    BCard,
    BTable,
    BPagination,
    BCardFooter,
    BSpinner,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'unit',
          label: 'BİRİM',
          thClass: 'width-100 text-center text-nowrap align-middle',
          tdClass: 'width-100 text-center text-nowrap align-middle',
          thStyle: { width: '150px !important' },
        },
        {
          key: 'unit_cost',
          label: 'BİRİM MALİYET',
          thClass: 'text-center text-nowrap align-middle',
          tdClass: 'text-center text-nowrap align-middle',
          thStyle: { width: '150px !important' },
        },
        {
          key: 'unit_sale',
          label: 'TAVSİYE EDİLEN BİRİM SATIŞ FİYATI',
          thClass: 'text-center text-nowrap align-middle',
          tdClass: 'text-center text-nowrap align-middle',
          thStyle: { width: '150px !important' },
        },
        {
          key: 'tax',
          label: 'KDV Oranı',
          thClass: 'text-center text-nowrap align-middle',
          tdClass: 'text-center text-nowrap align-middle',
          thStyle: { width: '150px !important' },
        },
        {
          key: 'notes',
          label: 'Notlar',
          thClass: 'width-auto text-left align-middle',
          tdClass: 'width-auto text-left align-middle',
        },
        {
          key: 'username',
          label: 'GÜNCELLEME',
          thClass: 'text-nowrap text-left align-middle',
          tdClass: 'text-nowrap text-left align-middle',
          thStyle: { width: '180px !important' },
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          'units.title As unit',
          `${tableName}.quantity AS quantity`,
          `${tableName}.unit_cost AS unit_cost`,
          `${tableName}.unit_sale AS unit_sale`,
          `${tableName}.notes AS notes`,
          `${tableName}.modified AS modified`,
          'currencies.str_value_2 AS currency',
          'taxes.title AS tax',
          'users.name AS username',
        ],
        where: {
          'product_prices.id_products': this.$route.params.id,
        },
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    loading() {
      return this.$store.getters['productPrices/loading']
    },
    emptyText() {
      if (this.loading === true) {
        return 'Lütfen bekleyiniz...'
      }
      if (this.dataList.length === 0) {
        return 'İçerik bulunamadı.'
      }
      return null
    },
    dataList() {
      return this.$store.getters['productPrices/dataList']
    },
    dataCounts() {
      return this.$store.getters['productPrices/dataCounts']
    },
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('productPrices/getDataList', this.dataQuery)
    },
  },
}
</script>
